module.exports = __webpack_public_path__ + "img/stores_virtuell_appointment@2x.dbd0018.webp";